import { render, staticRenderFns } from "./DetalhesProgramacao.vue?vue&type=template&id=09ee6e5a"
import script from "./DetalhesProgramacao.vue?vue&type=script&lang=js"
export * from "./DetalhesProgramacao.vue?vue&type=script&lang=js"
import style0 from "./DetalhesProgramacao.vue?vue&type=style&index=0&id=09ee6e5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports